import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "./assets/css/global.css";
import "./assets/css/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import plugins from "./plugins"; // plugins
import "./permission";
import permissionDirective from "./directives/permission.js"; // 权限指令

// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
Vue.component("ImageUpload", ImageUpload);
// 文件上传组件
import FileUpload from "@/components/FileUpload";
Vue.component("FileUpload", FileUpload);

import navBack from "@/components/NavBack.vue";
Vue.component("navBack", navBack);

Vue.prototype.$store = store; // 全局注册store

Vue.use(ElementUI);
Vue.use(plugins); // 使用插件
Vue.use(permissionDirective); // 注册权限指令

Vue.config.productionTip = false;

// main.js 或 router/index.js
router.beforeEach((to, from, next) => {
  // 每次路由切换前执行滚动到顶部的操作
  window.scrollTo(0, 0);
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
